// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Analytics20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Analytics20Circle: FC<Analytics20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-6.56-5.44c.294.293.647.44 1.06.44H19v-1.5H6.5V5H5v12.5c0 .413.147.766.44 1.06ZM7.5 9.5v7h3v-7h-3Zm4-3.5v10.5h3V6h-3Zm4 6.5v4h3v-4h-3Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Analytics20Circle;
